import { createRouter, createWebHistory } from 'vue-router'

import { routes } from '@/features/router/routes.js'

export const router = createRouter({
  history: createWebHistory(),
  routes,
})
